const TerminalWindow = ({
  title = "terminal",
  children,
  maxWidth = "max-w-2xl",
  shortcuts,
  popular = false,
  id,
  className = "",
  contentClassName = "",
}) => {
  return (
    <div id={id} className={`${maxWidth} mx-auto h-full ${className}`}>
      <div className="rounded-lg border border-[#AC8E66]/20 overflow-hidden shadow-2xl shadow-black/40 h-full flex flex-col">

        {/* Title Bar */}
        <div className="flex items-center gap-2 px-4 py-2.5 bg-[#1a1a1a] border-b border-[#AC8E66]/10">
          <span className="w-3 h-3 rounded-full bg-[#ff5f57]" />
          <span className="w-3 h-3 rounded-full bg-[#febc2e]" />
          <span className="w-3 h-3 rounded-full bg-[#28c840]" />
          <span className="ml-3 text-xs text-[#AC8E66] select-none">{title}</span>
          {popular && (
            <span className="ml-auto text-[10px] text-[#AC8E66] border border-[#AC8E66]/30 rounded px-1.5 py-0.5 select-none">
              popular
            </span>
          )}
        </div>

        {/* Content */}
        <div className={`px-4 sm:px-6 py-5 sm:py-6 bg-[#0F0F0F] font-mono flex-1 ${contentClassName}`}>
          {children}
        </div>

        {/* Shortcut Bar */}
        {shortcuts && shortcuts.length > 0 && (
          <div className="flex items-center gap-3 px-4 sm:px-6 py-2.5 bg-[#1a1a1a] border-t border-[#AC8E66]/10 overflow-x-auto">
            {shortcuts.map((s) => (
              <button
                key={s.key}
                onClick={s.onClick}
                className="flex items-center gap-1.5 text-xs text-[#EFEBDC]/50 hover:text-[#EFEBDC]/80 transition-colors cursor-pointer flex-none"
              >
                <kbd className="inline-flex items-center justify-center w-5 h-5 rounded border border-[#AC8E66]/30 bg-[#AC8E66]/10 text-[#AC8E66] text-[10px] font-mono leading-none">
                  {s.key}
                </kbd>
                <span>{s.label}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TerminalWindow;
